import { useMemo } from 'react';
import { useBaseI18n } from './i18n-hooks';
var useBanks = function () {
    var banks = useBaseI18n(function (i18n) { return i18n.banks; });
    var bankOptions = useMemo(function () {
        return Object.entries(banks).map(function (_a) {
            var id = _a[0], value = _a[1];
            return ({ id: id, value: value });
        });
    }, [banks]);
    return bankOptions;
};
export default useBanks;
//# sourceMappingURL=useBanks.js.map